import style from './ToolPlayController.module.css';

const genCn = <N extends string>(name: N) => {
  return {
    get() {
      return style[name];
    },

    toString() {
      return name;
    },

    child<C extends string>(childName: C) {
      return genCn(`${name}__${childName}`);
    },
  };
};

const HOST_CLASSNAME = 'toolPlayController';

export const CLASSNAME = {
  HOST: genCn(HOST_CLASSNAME),
  get WRAPPER() {
    return this.HOST.child('wrapper');
  },
  get TOP() {
    return this.WRAPPER.child('top');
  },
  get BOTTOM() {
    return this.WRAPPER.child('bottom');
  },
  get BUTTON() {
    return this.WRAPPER.child('button');
  },
  get FRAME_MOVE() {
    return this.BOTTOM.child('frame-move');
  },
  get TASK_MOVE() {
    return this.BOTTOM.child('task-move');
  },

  FRAMEBAR: genCn(`${HOST_CLASSNAME}FrameBar`),
  get TICKER_LIST() {
    return this.FRAMEBAR.child('ticker-list');
  },
  get TICKER_LIST_CONTAINER() {
    return this.TICKER_LIST.child('container');
  },
  get TICKER_LIST_GRAB() {
    return this.TICKER_LIST.child('grab');
  },
  get TICKER_LIST_GROUP() {
    return this.TICKER_LIST.child('group');
  },
  get TICKER_LIST_GROUP_ITEM() {
    return this.TICKER_LIST_GROUP.child('item');
  },
  get TICKER_LIST_GROUP_ITEM_TEXT() {
    return this.TICKER_LIST_GROUP_ITEM.child('text');
  },
  get TICKER_LIST_GROUP_ITEM_TEXT_EM() {
    return this.TICKER_LIST_GROUP_ITEM_TEXT.child('em');
  },
  get TICKER_LIST_GROUP_ITEM_TEXT_BOUNDARY() {
    return this.TICKER_LIST_GROUP_ITEM_TEXT.child('boundary');
  },
  get TICKER_LIST_GROUP_ITEM_TEXT_OUTER() {
    return this.TICKER_LIST_GROUP_ITEM_TEXT.child('outer');
  },
};

type ZoomList = Exclude<NumberRange<11>, 0>;

export const ZOOM = {
  DEFAULT: 5 as ZoomList,
  MAX: 5 as ZoomList,
  MIN: 5 as ZoomList,
};

export const TICK_AND_TICK_INTERVAL_BY_ZOOM: {
  [K in ZoomList]: [number, number];
} = {
  10: [25, 1],
  9: [25, 1],
  8: [50, 1],
  7: [50, 1],
  6: [75, 1],
  5: [75, 1],
  4: [100, 5],
  3: [100, 5],
  2: [125, 25],
  1: [125, 25],
};

export const TICKWIDTH_BY_ZOOM: {
  [K in ZoomList]: number;
} = {
  10: 60,
  9: 56,

  8: 52,
  7: 48,

  6: 44,
  5: 40,

  4: 36,
  3: 32,

  2: 28,
  1: 24,
};
